const defaultCenter = {
  lat: 12.973350842784585,
  lng: 77.59041167657121,
};

const sampleMarker = [
  {
    key: '999',
    position: defaultCenter,
    icon: {
      path: 'M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z',
      fillColor: '#A1CA8E',
      fillOpacity: 1,
      strokeWeight: 1,
      rotation: 0,
      scale: 0.1,
      strokeColor: '#A1CA8E',
    },
  },
];

const defaultLiveVehiclePosition = {
  lat: 12.9330036,
  lng: 77.6230767,
};

const defaultPickupPosition = {
  lat: 12.9422305,
  lng: 77.6081528,
};

const defaultDeviatedPickupPosition = {
  lat: 12.9432305,
  lng: 77.6081528,
};

const defaultDeviatedDropPosition = {
  lat: 12.9243155,
  lng: 77.6298221,
};

const defaultDropPosition = {
  lat: 12.9243155,
  lng: 77.6295221,
};

const svg =
  '<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M35.5483 12.2365C44.6519 6.94698 55.8417 7.03943 64.8598 12.4787C73.7893 18.0288 79.2164 27.9341 79.1662 38.5893C78.958 49.1747 73.1386 59.125 65.8644 66.817C61.6659 71.2767 56.9691 75.2201 51.8701 78.5668C51.3449 78.8705 50.7697 79.0738 50.1728 79.1667C49.5982 79.1422 49.0387 78.9724 48.5447 78.6727C40.76 73.644 33.9305 67.2252 28.3846 59.7248C23.744 53.464 21.1076 45.9 20.8333 38.0601L20.854 36.9195C21.2329 26.686 26.7699 17.3372 35.5483 12.2365ZM53.7802 29.3116C50.0794 27.7385 45.8126 28.5931 42.9721 31.4764C40.1315 34.3598 39.2776 38.703 40.8089 42.4782C42.3403 46.2535 45.9548 48.716 49.9649 48.716C52.592 48.7349 55.1174 47.6826 56.9783 45.7936C58.8392 43.9047 59.8811 41.336 59.8718 38.6599C59.8858 34.5751 57.481 30.8846 53.7802 29.3116Z" fill="#007BC0"/> <path opacity="0.4" d="M49.9998 91.6667C61.5058 91.6667 70.8332 89.8012 70.8332 87.5C70.8332 85.1988 61.5058 83.3333 49.9998 83.3333C38.4939 83.3333 29.1665 85.1988 29.1665 87.5C29.1665 89.8012 38.4939 91.6667 49.9998 91.6667Z" fill="black" fill-opacity="0.35"/> <circle cx="50" cy="37.931" r="24.1379" fill="white"/> </svg>';
const defaultMarker = {
  key: 'defaultMarker',
  position: defaultLiveVehiclePosition,
  // icon: {
  //   path: 'M 225 1.514 C 116.021 14.978, 26.943 97.036, 4.936 204.237 C -0 228.284, -1.440 262.012, 1.446 286 C 14.635 395.625, 96.590 484.965, 204.237 507.064 C 228.284 512, 262.012 513.440, 286 510.554 C 387.650 498.325, 471.879 427.589, 501.459 329.612 C 505.735 315.449, 509.684 296.228, 510.618 285.032 C 510.989 280.580, 511.677 276.700, 512.146 276.410 C 512.616 276.119, 512.993 266.346, 512.985 254.691 C 512.976 242.958, 512.597 234.088, 512.134 234.817 C 511.624 235.621, 511.030 232.913, 510.609 227.869 C 510.230 223.323, 508.782 213.766, 507.391 206.631 C 493.742 136.634, 450.783 74.951, 389.591 37.486 C 357.335 17.738, 323.015 5.908, 285.122 1.475 C 269.865 -0.310, 239.603 -0.290, 225 1.514 M 368 127.427 C 323.043 145.164, 128.093 225.483, 126.741 226.825 C 122.658 230.883, 122.958 239.627, 127.277 242.434 C 128.500 243.228, 151.325 252.494, 178 263.023 C 204.675 273.553, 227.031 282.693, 227.679 283.334 C 228.328 283.975, 237.489 305.875, 248.037 332 C 258.586 358.125, 267.840 380.710, 268.602 382.189 C 271.523 387.856, 279.038 389.850, 283.763 386.213 C 286.768 383.900, 387 139.295, 387 134.275 C 387 129.581, 385.433 127.079, 381.452 125.415 C 377.152 123.619, 377.961 123.498, 368 127.427 M 0.425 256 C 0.425 267.825, 0.569 272.663, 0.746 266.750 C 0.923 260.837, 0.923 251.162, 0.746 245.250 C 0.569 239.338, 0.425 244.175, 0.425 256',
  //   // path: 'M208.49,416.979c115.145,0,208.489-93.344,208.489-208.489C416.979,93.343,323.635,0,208.489,0C93.344,0,0,93.343,0,208.489C0,323.635,93.343,416.979,208.49,416.979z M125.715,294.676l73.508-179.938c1.537-3.762,5.195-6.219,9.258-6.219c4.06,0,7.72,2.457,9.255,6.218l73.527,179.943c1.619,3.961,0.535,8.515-2.689,11.324c-1.865,1.623-4.209,2.457-6.568,2.457c-1.725,0-3.459-0.443-5.021-1.353l-68.506-39.784l-68.485,39.78c-3.701,2.149-8.359,1.704-11.587-1.104C125.178,303.19,124.096,298.637,125.715,294.676z',
  //   fillColor: '#007BC0',
  //   fillOpacity: 1,
  //   strokeWeight: 2,
  //   rotation: -45,
  //   scale: 0.07,
  //   strokeColor: '#fff',
  //   anchor: { x: 90, y: 390 },
  //   labelOrigin: { x: 680, y: 25 },
  // },
  icon: {
    url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),
    scale: 0.1,
    anchor: { x: 50, y: 70 },
    labelOrigin: { x: 50, y: 38 },
  },
  label: {
    text: '+1',
    color: '#007BC0',
    fontSize: '16px',
    fontWeight: '700',
  },
};
const defaultPickupMarker = {
  key: '999999',
  position: defaultPickupPosition,
  icon: {
    path: 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    fillColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    strokeColor: '#151B26',
    anchor: { x: 200, y: 500 },
  },
};

const defaultDeviatedPickupMarker = {
  key: '9999',
  position: defaultDeviatedPickupPosition,
  icon: {
    path: 'M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z',
    strokeColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    fillColor: '#151B26',
    anchor: { x: 200, y: 500 },
  },
};

const defaultDeviatedDropMarker = {
  key: '9',
  position: defaultDeviatedDropPosition,
  icon: {
    path: 'M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z',
    strokeColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    fillColor: '#CF2929',
    anchor: { x: 200, y: 500 },
  },
};

const defaultDropMarker = {
  key: '999',
  position: defaultDropPosition,
  icon: {
    path: 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    fillColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    strokeColor: '#CF2929',
    anchor: { x: 200, y: 500 },
  },
};

const samplePathData = {
  key: 'rbLite',
  path: [],
  strokeColor: '#00A4FD',
  borderColor: '#0088D4',
  normalWidth: 4,
};

const overviewPathData = {
  key: 'rbLite',
  path: [],
  strokeColor: '#56B0FF',
  borderColor: '#56B0FF',
  normalWidth: 9,
};

const liveLocationMarker = {
  key: '99999',
  position: {
    lat: 12.9447518,
    lng: 77.6073086,
  },
  icon: {
    path: 'M 225 1.514 C 116.021 14.978, 26.943 97.036, 4.936 204.237 C -0 228.284, -1.440 262.012, 1.446 286 C 14.635 395.625, 96.590 484.965, 204.237 507.064 C 228.284 512, 262.012 513.440, 286 510.554 C 387.650 498.325, 471.879 427.589, 501.459 329.612 C 505.735 315.449, 509.684 296.228, 510.618 285.032 C 510.989 280.580, 511.677 276.700, 512.146 276.410 C 512.616 276.119, 512.993 266.346, 512.985 254.691 C 512.976 242.958, 512.597 234.088, 512.134 234.817 C 511.624 235.621, 511.030 232.913, 510.609 227.869 C 510.230 223.323, 508.782 213.766, 507.391 206.631 C 493.742 136.634, 450.783 74.951, 389.591 37.486 C 357.335 17.738, 323.015 5.908, 285.122 1.475 C 269.865 -0.310, 239.603 -0.290, 225 1.514 M 368 127.427 C 323.043 145.164, 128.093 225.483, 126.741 226.825 C 122.658 230.883, 122.958 239.627, 127.277 242.434 C 128.500 243.228, 151.325 252.494, 178 263.023 C 204.675 273.553, 227.031 282.693, 227.679 283.334 C 228.328 283.975, 237.489 305.875, 248.037 332 C 258.586 358.125, 267.840 380.710, 268.602 382.189 C 271.523 387.856, 279.038 389.850, 283.763 386.213 C 286.768 383.900, 387 139.295, 387 134.275 C 387 129.581, 385.433 127.079, 381.452 125.415 C 377.152 123.619, 377.961 123.498, 368 127.427 M 0.425 256 C 0.425 267.825, 0.569 272.663, 0.746 266.750 C 0.923 260.837, 0.923 251.162, 0.746 245.250 C 0.569 239.338, 0.425 244.175, 0.425 256',
    // path: 'M208.49,416.979c115.145,0,208.489-93.344,208.489-208.489C416.979,93.343,323.635,0,208.489,0C93.344,0,0,93.343,0,208.489C0,323.635,93.343,416.979,208.49,416.979z M125.715,294.676l73.508-179.938c1.537-3.762,5.195-6.219,9.258-6.219c4.06,0,7.72,2.457,9.255,6.218l73.527,179.943c1.619,3.961,0.535,8.515-2.689,11.324c-1.865,1.623-4.209,2.457-6.568,2.457c-1.725,0-3.459-0.443-5.021-1.353l-68.506-39.784l-68.485,39.78c-3.701,2.149-8.359,1.704-11.587-1.104C125.178,303.19,124.096,298.637,125.715,294.676z',
    fillColor: '#A2C98E',
    fillOpacity: 1,
    strokeWeight: 2,
    rotation: -45,
    scale: 0.07,
    strokeColor: '#fff',
    anchor: { x: 90, y: 390 },
  },
};

const dropMarker = {
  key: '999',
  position: {
    lat: 12.9443298,
    lng: 77.6052318,
  },
  icon: {
    path: 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    fillColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    strokeColor: '#CF2929',
    anchor: { x: 200, y: 500 },
  },
};

const pickupMarker = {
  key: '999999',
  position: {
    lat: 12.9485507,
    lng: 77.6047709,
  },
  icon: {
    path: 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
    fillColor: 'transparent',
    fillOpacity: 1,
    strokeWeight: 3,
    rotation: 0,
    scale: 0.06,
    strokeColor: '#151B26',
    anchor: { x: 200, y: 500 },
  },
};

const defaultNewCenter = {
  lat: 12.9243905,
  lng: 77.6287598,
};

const sampleTraceMarkStart = {
  lat: 12.9339685,
  lng: 77.6168213,
};

const circlesData = [
  {
    options: {
      strokeColor: 'green',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: 'green',
      fillOpacity: 0.1,
    },
    center: defaultDeviatedPickupPosition,
    radius: 200,
    key: '123',
  },
  {
    options: {
      strokeColor: 'orange',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: 'orange',
      fillOpacity: 0.1,
    },
    center: defaultDeviatedPickupPosition,
    radius: 500,
    key: '1234',
  },
];

export {
  defaultCenter,
  sampleMarker,
  samplePathData,
  defaultDropMarker,
  defaultDropPosition,
  defaultLiveVehiclePosition,
  defaultMarker,
  defaultPickupMarker,
  defaultPickupPosition,
  defaultDeviatedPickupMarker,
  defaultDeviatedPickupPosition,
  defaultDeviatedDropMarker,
  defaultDeviatedDropPosition,
  dropMarker,
  liveLocationMarker,
  pickupMarker,
  defaultNewCenter,
  sampleTraceMarkStart,
  circlesData,
  overviewPathData,
};
